import styled from "styled-components";

const FormSectionTitle = styled.p`
  position: relative;
  font-weight: 500;

  &::before {
    content: "";
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 50px;
    border-bottom: 2px solid var(--primary-text-color);
    opacity: 0.6;
  }
`;

export default FormSectionTitle;
